import { createBrowserClient } from "@supabase/ssr";

let client: ReturnType<typeof createBrowserClient> | null = null;
let clientInitialized = false;

const INVALID_ENV_LITERALS = new Set(["undefined", "null"]);

const readEnv = (value: string | undefined) => {
  const trimmed = value?.trim();
  if (!trimmed) return undefined;

  const normalized = trimmed.toLowerCase();
  if (INVALID_ENV_LITERALS.has(normalized)) return undefined;

  return trimmed;
};

export function createClient() {
  if (clientInitialized) return client;

  const url = readEnv(process.env.NEXT_PUBLIC_SUPABASE_URL);
  const key = readEnv(process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY);

  if (!url || !key) {
    if (process.env.NODE_ENV !== "production") {
      console.warn(
        `[v0] Supabase não está configurado corretamente. Verifique NEXT_PUBLIC_SUPABASE_URL e NEXT_PUBLIC_SUPABASE_ANON_KEY. URL: ${url ? "OK" : "MISSING"}, anon key: ${key ? "OK" : "MISSING"}.`
      );
    }
    clientInitialized = true;
    return null;
  }

  client = createBrowserClient(url, key);
  clientInitialized = true;

  return client;
}
